module.exports = __webpack_public_path__ + "img/copy1.e619616a.svg";